import React from 'react';
import {View} from 'react-native';

import {LoadingBox} from '/component/base/LoadingBox';

import {styles} from './Loading.style';

export const Loading = () => (
  <View style={styles.header}>
    <LoadingBox style={styles.avatar} />
    <View style={styles.headerText}>
      <View style={styles.nameContainer}>
        <LoadingBox style={styles.firstName} />
        <LoadingBox style={styles.lastName} />
      </View>
      <LoadingBox style={styles.activationDate} />
    </View>
  </View>
);

export default Loading;
